import { useContext, useEffect } from "react";

import { WhitelabelContext } from "@/providers/whitelabel-provider";

export function usePageTitle(title: string): void {
  const ctx = useContext(WhitelabelContext);
  const appName = ctx?.config?.partnerName ?? "NoLimit Creatives";

  useEffect(() => {
    if (!title) return;
    document.title = `${title} - ${appName}`;
  }, [title, appName]);
}
